export const organizerSharedGuardOrganizationMandatoryFieldsToggle = [
  'name',
  'description',
  'entityType',
  'legalName',
  'taxId',
  'founderGivenName',
  'founderFamilyName',
  'email',
  'telephone',
  'address.streetAddress',
  'termsOfUsageAccepted',
];
